"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuManager = void 0;
var inversify_1 = require("inversify");
var IMenuManager_1 = require("../IMenuManager");
var EventEmitter_1 = require("./EventEmitter");
var MenuManager = exports.MenuManager = /** @class */ (function (_super) {
    __extends(MenuManager, _super);
    function MenuManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menus = [];
        _this.menusById = new Map();
        return _this;
    }
    MenuManager.prototype.add = function (menuItem) {
        this.menus.push(menuItem);
        this.menusById.set(menuItem.id, menuItem);
        this.emit(IMenuManager_1.MenuEvent.Add, menuItem);
        this.emit(IMenuManager_1.MenuEvent.Change);
    };
    MenuManager.prototype.addByPath = function (menuItem) {
        var path = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            path[_i - 1] = arguments[_i];
        }
        var items = this.menus;
        path.forEach(function (id) {
            var item = items.find(function (x) { return x.id === id; });
            if (item === undefined) {
                throw new Error("Cannot find item by ID: ".concat(id));
            }
            if (item.childs === undefined) {
                item.childs = [];
            }
            items = item.childs;
        });
        items.push(menuItem);
        this.menusById.set(menuItem.id, menuItem);
        this.emit(IMenuManager_1.MenuEvent.Add, menuItem);
        this.emit(IMenuManager_1.MenuEvent.Change);
    };
    MenuManager.prototype.getMenus = function () {
        return this.menus;
    };
    MenuManager.prototype.update = function (id, data) {
        if (data.id && data.id !== id) {
            throw new Error("ID can't be modified");
        }
        var menuItem = this.menusById.get(id);
        if (!menuItem) {
            throw new Error("Menu item does not exist: ".concat(id));
        }
        menuItem = Object.assign(menuItem, data); // Merge data
        this.menusById.set(id, menuItem); // Update data
        this.emit(IMenuManager_1.MenuEvent.Change);
    };
    MenuManager.prototype.get = function (id) {
        return this.menusById.get(id);
    };
    MenuManager = __decorate([
        (0, inversify_1.injectable)()
    ], MenuManager);
    return MenuManager;
}(EventEmitter_1.EventEmitter));
//# sourceMappingURL=MenuManager.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/services/impl/MenuManager.js
// module id = 864
// module chunks = 0